// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2b-1";
export var movingGradient = "_2b-4";
export var movingGradientBlock = "_2b-2";
export var skeleton = "_2b-0";
export var skeletonText = "_2b-3";